import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { reset } from "../mutators";
import UserAPI from "../../modules/dealer/API/UserAPI";
import DealerOnboardingAPI from "../../modules/dealer/API/DealerOnboardingAPI";
import Stats from "../../modules/dealer/models/Stats";

interface IStats {
    dealershipStats: Stats;
    dealershipUserStats: Stats;
}

const initialStats: Stats = {
    all: 0,
    invited: 0,
    active: 0,
};

const initialState: IStats = {
    dealershipStats: initialStats,
    dealershipUserStats: initialStats,
};

export const StatsSlice = createSlice({
    name: "stats",
    initialState,
    reducers: {
        // Set State
        SET_DEALERSHIP_STATS: (state, action) => {
            state.dealershipStats = action.payload;
        },
        SET_DEALERSHIP_USER_STATS: (state, action) => {
            state.dealershipUserStats = action.payload;
        },
        // Reset State
        USER_RESET: (state) => {
            reset(state, initialState);
        },
    },
});

// Actions
export const getDealershipsStats = createAsyncThunk(
    "user/getDealershipStats",
    async (_: void, { dispatch }) => {
        let dealershipsStats: Stats = initialStats;

        await DealerOnboardingAPI.GetDealershipsStats().then(
            (res) => (dealershipsStats = res.data.data)
        );

        dispatch(SET_DEALERSHIP_STATS(dealershipsStats));
    }
);

export const getDealershipUserStats = createAsyncThunk(
    "user/getDealershipUserStats",
    async (_: void, { dispatch }) => {
        let dealershipUserStats: Stats = initialStats;

        await UserAPI.getDealershipUserStats().then(
            (res) => (dealershipUserStats = res.data.data)
        );

        dispatch(SET_DEALERSHIP_USER_STATS(dealershipUserStats));
    }
);

export const { SET_DEALERSHIP_STATS, SET_DEALERSHIP_USER_STATS, USER_RESET } =
    StatsSlice.actions;

export default StatsSlice.reducer;
